<template>
    <div class="flex items-center">
        <!-- eslint-disable vue/no-v-html -->
        <label
            for="pageSizeSelector-pageSize"
            class="text-sm text-tertiary"
            v-html="`${t('baseComponents.basePagination.pageSize')}: `"
        />
        <BaseFieldSelect
            id="pageSizeSelector-pageSize"
            name="pageSizeSelector-pageSize"
            :model-value="String(pageSize)"
            :options="selectOptions"
            data-spec-class="pageSize"
            class="ml-2 !w-auto"
            @update:model-value="handleChange"
        />
    </div>
    <!-- eslint-enable vue/no-v-html -->
</template>

<script setup lang="ts">
import { withDefaults, defineProps, defineEmits, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Theme, SelectOption } from '@/types';
import BaseFieldSelect from '@/components/BaseFieldSelect.vue';

const { t } = useI18n();

interface PageSizeSelectorProps {
    theme?: Theme;
    pageSize: number;
    pageSizes?: number[];
}

const props = withDefaults(defineProps<PageSizeSelectorProps>(), {
    theme: Theme.Light,
    pageSizes: () => [15, 30, 50, 100],
});

const emits = defineEmits(['change']);

const selectOptions = computed<SelectOption[]>(() => {
    return props.pageSizes.map((size) => ({
        key: String(size),
        label: String(size),
    }));
});

function handleChange(value: string) {
    emits('change', Number(value));
}
</script>
